import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["checked", "className", "compact", "defaultChecked", "disabled", "dynamicWidth", "id", "innerRef", "labelVisual", "activeLabel", "inactiveLabel", "labelA11y", "name", "onChange", "onClick", "showOnOff", "tabIndex", "value"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { A11yOnly } from '@lmig/lmds-react-a11y';
import { uniqueId } from '@lmig/lmds-helpers/dist/uniqueId';
import "./toggle.css";
/**
 * @see [LMDS Toggle documentation and examples](https://designsystem.lmig.com/components/toggles/code)
 *
 * API:
 *
 * @implements [ToggleProps](https://designsystem.lmig.com/components/toggles/code#toggle-props)
 * @extends [HTMLDivElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmldivelement.html)
 */
export var Toggle = function Toggle(props) {
  var checked = props.checked,
    className = props.className,
    _props$compact = props.compact,
    compact = _props$compact === void 0 ? false : _props$compact,
    defaultChecked = props.defaultChecked,
    disabled = props.disabled,
    _props$dynamicWidth = props.dynamicWidth,
    dynamicWidth = _props$dynamicWidth === void 0 ? false : _props$dynamicWidth,
    idProp = props.id,
    innerRef = props.innerRef,
    labelVisual = props.labelVisual,
    _props$activeLabel = props.activeLabel,
    activeLabel = _props$activeLabel === void 0 ? 'On' : _props$activeLabel,
    _props$inactiveLabel = props.inactiveLabel,
    inactiveLabel = _props$inactiveLabel === void 0 ? 'Off' : _props$inactiveLabel,
    labelA11y = props.labelA11y,
    name = props.name,
    onChange = props.onChange,
    onClick = props.onClick,
    _props$showOnOff = props.showOnOff,
    showOnOff = _props$showOnOff === void 0 ? true : _props$showOnOff,
    tabIndex = props.tabIndex,
    valueProp = props.value,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(checked !== undefined),
    _useState2 = _slicedToArray(_useState, 1),
    isControlled = _useState2[0];
  var _useState3 = useState(!!defaultChecked),
    _useState4 = _slicedToArray(_useState3, 2),
    isUncontrolledChecked = _useState4[0],
    setIsUncontrolledChecked = _useState4[1];
  var _useState5 = useState(function () {
      return uniqueId('Toggle-');
    }),
    _useState6 = _slicedToArray(_useState5, 1),
    toggleId = _useState6[0];
  var visualRef = useRef(null);
  var labelRef = useRef(null);
  var id = idProp || (name ? "".concat(toggleId, "-").concat(name.trim().replace(/\W/g, '-')) : "".concat(toggleId));
  var value = valueProp || 'default-value';
  var primaryLabelId = "".concat(id, "-label");

  // If the component is controlled with the "checked" prop we can rely on the value
  // of that prop directly and don't need to manage the checked state internally.
  // Otherwise (when uncontrolled) the checked state is tracked with isUncontrolledChecked.
  var isChecked = isControlled ? checked : isUncontrolledChecked;
  useEffect(function () {
    if (!isControlled && checked !== undefined) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.error('Warning: A component is changing an uncontrolled <Toggle> to be controlled.', 'This is likely caused by the "checked" prop changing from an initial undefined value to a defined value, ', 'which should not happen. Decide between using a controlled or uncontrolled Toggle for the lifetime of the ', 'component. More info: https://reactjs.org/link/controlled-components');
      }
      setIsUncontrolledChecked(checked);
    }
  }, [checked, isControlled]);
  function handleClick(e) {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      if (onClick) {
        onClick(e, isChecked);
      }
      return;
    }
    if (onClick) {
      onClick(e, !isChecked);
    }

    // Focus the button when clicking anywhere within the component.
    if (visualRef.current) {
      visualRef.current.focus();
    }
  }
  function handleChange(e) {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (onChange) {
      onChange(e, e.target.checked);
    }
    if (!isControlled) {
      setIsUncontrolledChecked(e.target.checked);
    }
  }

  // This component relies on the labels to initiate the click on the input.
  // However, placing the button inside of the <label> is problematic in IE11.
  // button.onClick works to trigger a label click for all browsers except IE11
  // where it results in double onClick calls that cancel each other out.
  function simulateLabelClick(e) {
    if (labelRef.current) {
      labelRef.current.click();
    }
    e.stopPropagation();
    e.preventDefault();
  }
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: classNames('lmig-Toggle', {
      'lmig-Toggle--compact': compact
    }, {
      'lmig-Toggle--dynamicWidth': dynamicWidth
    }, className)
  }), /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: id,
    name: name,
    value: value,
    className: "lmig-Toggle-input",
    "aria-disabled": disabled,
    "aria-hidden": true,
    "aria-labelledby": primaryLabelId,
    onClick: handleClick,
    onChange: handleChange,
    tabIndex: -1,
    ref: innerRef,
    checked: isChecked
  }), /*#__PURE__*/React.createElement("label", {
    id: primaryLabelId,
    className: "lmig-Toggle-label",
    htmlFor: id,
    ref: labelRef
  }, labelVisual && /*#__PURE__*/React.createElement("div", {
    className: "lmig-Toggle-text",
    "aria-hidden": labelA11y ? 'true' : undefined
  }, labelVisual), labelA11y && /*#__PURE__*/React.createElement(A11yOnly, null, labelA11y), /*#__PURE__*/React.createElement("button", {
    "aria-labelledby": primaryLabelId,
    role: "checkbox",
    "aria-checked": isChecked,
    "aria-disabled": disabled,
    type: "button",
    className: "lmig-Toggle-visual",
    ref: visualRef,
    onClick: simulateLabelClick,
    tabIndex: tabIndex
  })), showOnOff && /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: classNames('lmig-Toggle-state', {
      'lmig-Toggle-disabled': disabled
    })
  }, isChecked ? activeLabel : inactiveLabel));
};
Toggle.propTypes = {
  /** Add an optional ID to this element: `<input class="lmig-Toggle-input">`. If none is provided, a unique ID will be generated. */id: _pt.string,
  /** Add custom classes to this element: `<div class="lmig-Toggle">`. */className: _pt.string,
  /** Set a name for the element. */name: _pt.string,
  /** Set the checked value of the underlying input element. */value: _pt.string,
  /** Set the visual label. */labelVisual: _pt.node,
  /** Set a non-visual label to be used by assistive technologies (e.g., screen readers)
     * to replace the labelVisual in audio guidance. */
  labelA11y: _pt.string,
  /** Set compact styling.
        @default false
    */
  compact: _pt.bool,
  /** Set a component's width to 100% of the parent container's width.
        @default false
    */
  dynamicWidth: _pt.bool,
  /** Display the status text.
        @default true
    */
  showOnOff: _pt.bool,
  /** Set the initial state of the element (when uncontrolled). */defaultChecked: _pt.bool,
  /** Set the current selected state of the toggle (when controlled). */checked: _pt.bool,
  /** Set a reference to the DOM element (checkbox). */innerRef: _pt.oneOfType([_pt.string, _pt.func, _pt.object]),
  /** Custom active state label to the right of the toggle, this replaces `On` 
        @default = 'On'
    */
  activeLabel: _pt.node,
  /** Custom inactive state label to the right of the toggle, this replaces `Off` 
        @default = 'Off'
    */
  inactiveLabel: _pt.node,
  /** Set disabled styling. */disabled: _pt.bool,
  /** Pass additional functionality to run on change events. */onChange: _pt.func,
  /** Pass additional functionality to run on click events, even when the component is disabled. */onClick: _pt.func
};